var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBox = function SvgBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "#F9696A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0CBA0",
    d: "M11.061 18.22h22.85v-4.835H11.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6B083",
    d: "M31.23 36.903H13.743c-.624 0-1.13-.49-1.13-1.095V18.22h19.746v17.59c0 .604-.506 1.094-1.13 1.094"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EADBC5",
    d: "M28.716 9.063h-14.3l-3.355 4.322h22.85l-3.355-4.322"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8E7E5C",
    d: "M12.613 18.63h19.746v-.41H12.613z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13293D",
    d: "M24.32 22.593h-3.67c-.797 0-1.444-.627-1.444-1.4v-1.197h6.56v1.198c0 .772-.648 1.4-1.445 1.4"
  }))));
};
export { SvgBox as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NSIgaGVpZ2h0PSI0NSIgdmlld0JveD0iMCAwIDQ1IDQ1Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGNpcmNsZSBjeD0iMjIuNSIgY3k9IjIyLjUiIHI9IjIyLjUiIGZpbGw9IiNGOTY5NkEiIGZpbGwtcnVsZT0ibm9uemVybyIvPgogICAgICAgIDxwYXRoIGZpbGw9IiNFMENCQTAiIGQ9Ik0xMS4wNjEgMTguMjJoMjIuODV2LTQuODM1SDExLjA2eiIvPgogICAgICAgIDxwYXRoIGZpbGw9IiNDNkIwODMiIGQ9Ik0zMS4yMyAzNi45MDNIMTMuNzQzYy0uNjI0IDAtMS4xMy0uNDktMS4xMy0xLjA5NVYxOC4yMmgxOS43NDZ2MTcuNTljMCAuNjA0LS41MDYgMS4wOTQtMS4xMyAxLjA5NCIvPgogICAgICAgIDxwYXRoIGZpbGw9IiNFQURCQzUiIGQ9Ik0yOC43MTYgOS4wNjNoLTE0LjNsLTMuMzU1IDQuMzIyaDIyLjg1bC0zLjM1NS00LjMyMiIvPgogICAgICAgIDxwYXRoIGZpbGw9IiM4RTdFNUMiIGQ9Ik0xMi42MTMgMTguNjNoMTkuNzQ2di0uNDFIMTIuNjEzeiIvPgogICAgICAgIDxwYXRoIGZpbGw9IiMxMzI5M0QiIGQ9Ik0yNC4zMiAyMi41OTNoLTMuNjdjLS43OTcgMC0xLjQ0NC0uNjI3LTEuNDQ0LTEuNHYtMS4xOTdoNi41NnYxLjE5OGMwIC43NzItLjY0OCAxLjQtMS40NDUgMS40Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=";